<script lang="ts">
    import {onMount} from "svelte";

    // <TabContentView tabName="XXX" activeTabName={activeTabName}></TabContentView>

    export let activeTabName = '';


    export let tabName = '';
    export let tabDescription = '';

    onMount(() => {
        if (tabName === '') {
            console.error('tabContentView で tabName が指定されていません');
        }
    });


</script>

<div class="tab-content-view" data-tab-name={tabName} data-tab-description={tabDescription}>
    {#if tabName === activeTabName}
        <slot/>
    {/if}


</div>
<style lang="scss">
    .tab-content-view {

    }
</style>